module.exports = __webpack_public_path__ + "img/Ficha2_Localidades-Dona.27050a2b.png";